export enum ExpeditionTypeEnum {
  QUOTATION = "QUOTATION",
  CUSTOM_QUOTATION = "CUSTOM_QUOTATION",
}
